<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="大类" prop="category" required>
        <el-select v-model="form.category" placeholder="请选择大类" clearable>
          <el-option value="TEXT" label="文本"/>
          <el-option value="NUMBER" label="数字"/>
          <el-option value="IMAGE" label="图片"/>
          <el-option value="OBJECT" label="对象"/>
        </el-select>
      </el-form-item>
      <el-form-item label="字段变量名称" prop="variable" required>
        <el-input v-model="form.variable" placeholder="请输入字段变量名称" v-trim/>
      </el-form-item>
      <el-form-item label="类型名称" prop="label" required>
        <el-input v-model="form.label" placeholder="请输入类型名称" v-trim/>
      </el-form-item>
      <el-form-item v-if="form.category !== 'OBJECT'" label="数据来源" prop="dataRule" required>
        <el-select v-model="form.dataRule" placeholder="请选择数据来源" clearable>
          <el-option value="INPUT" label="自行录入"/>
          <el-option value="RULE" label="自定义规则"/>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.dataRule === 'RULE'" label="数据规则表达式" prop="dataRuleConfig">
        <el-input v-model="form.dataRuleConfig" placeholder="请输入数据规则表达式" v-trim/>
      </el-form-item>
      <el-form-item v-if="form.category === 'OBJECT'" label="字段配置" prop="fieldConfig" required>
        <ul>
          <li><el-button type="primary" size="mini" @click="addFieldRow">添加行</el-button></li>
        </ul>
        <el-table
          :data="fields"
          stripe
        >
          <el-table-column prop="variable" label="字段英文名称" min-width="100px">
            <el-input slot-scope="{row}" placeholder="请输入字段变量" v-model="row.variable" v-trim/>
          </el-table-column>
          <el-table-column prop="name" label="字段中文名称" min-width="100px">
            <el-input slot-scope="{row}" placeholder="请输入字段名称" v-model="row.label" v-trim/>
          </el-table-column>
          <el-table-column prop="type" label="字段类型" min-width="100px">
            <el-select slot-scope="{row}" v-model="row.type" placeholder="请选择类型">
              <el-option value="TEXT" label="文本"/>
              <el-option value="NUMBER" label="数字"/>
              <el-option value="IMAGE" label="图片"/>
            </el-select>
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="80"
            fixed="right"
          >
            <template slot-scope="{$index}">
              <el-button type="text" @click="deleteField($index)" icon="el-icon-delete">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaTemplateFieldTypeWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    const _this = this
    return {
      fields: [],
      // 表单数据
      form: {
        id: null,
        category: null,
        variable: '',
        label: '',
        dataRule: null,
        dataRuleConfig: null,
        fieldConfig: null
      },
      // 验证规则
      rules: {
        category: [
          { required: true, message: '请选择大类' }
        ],
        variable: [
          { required: true, message: '请输入字段变量名称' },
          { validator: _this.checkEnName }
        ],
        label: [
          { required: true, message: '请输入类型名称' }
        ],
        dataRule: [
          { required: true, message: '请选择数据来源' }
        ]
      }
    }
  },
  computed: {
    category () {
      return [this.form.category]
    }
  },
  watch: {
    // 字段变更时自动更新fieldConfig
    fields () {
      this.form.fieldConfig = JSON.stringify(this.fields)
    },
    // 大类变更时更新数据来源方式等信息
    category (newValue) {
      // 大类为对象时，数据来源更新为手动输入
      if (newValue[0] === 'OBJECT') {
        this.form.dataRule = 'INPUT'
      }
    }
  },
  methods: {
    // 验证模块英文名称
    checkEnName (rule, value, callback) {
      if (value.length < 3) {
        callback(new Error('变量名称必须大于2个字符'))
        return
      }
      if (!/^[a-z]+[a-z0-9_]+$/.test(value)) {
        callback(new Error('变量名称必须为小写字母，特殊字符仅允许使用"_"，且不能以"_"和数字开头'))
        return
      }
      callback()
    },
    /**
     * 打开窗口
     */
    open (title, target) {
      this.title = title
      this.visible = true
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.fields = []
        if (this.form.fieldConfig != null || this.form.fieldConfig !== '') {
          try {
            this.fields = JSON.parse(this.form.fieldConfig)
          } catch (e) {
            console.error('字段配置错误,配置值：' + this.form.fieldConfig)
          }
        }
      })
    },
    /**
     * 确认（点击确认按钮后触发）
     */
    confirm () {
      if (!this.__checkFieldConfig()) {
        return
      }
      this.form.fieldConfig = JSON.stringify(this.fields)
      if (this.form[this.configData['field.id']] == null || this.form[this.configData['field.id']] === '') {
        this.__confirmCreate()
        return
      }
      this.__confirmEdit()
    },
    // 添加字段行
    addFieldRow () {
      this.fields.push({
        variable: '',
        label: '',
        type: 'TEXT'
      })
    },
    // 删除字段行
    deleteField (index) {
      const field = this.fields[index]
      if (field.variable.trim() === '' && field.label.trim() === '') {
        this.fields.splice(index, 1)
        return
      }
      let fieldName = field.label
      if (fieldName.trim().length === 0) {
        fieldName = field.variable
      }
      this.$dialog.deleteConfirm(`确认删除【${fieldName}】字段配置吗`)
        .then(() => {
          this.fields.splice(index, 1)
        })
        .catch(() => {})
    },
    // 检查字段配置
    __checkFieldConfig () {
      if (this.form.category === 'OBJECT') {
        if (this.fields.length === 0) {
          this.$tip.warning('请至少添加一条字段配置记录')
          return false
        }
        for (const field of this.fields) {
          if (field.variable.trim() === '') {
            this.$tip.warning('字段配置中，字段英文名称不能为空')
            return false
          }
          if (field.variable.trim().length < 3) {
            this.$tip.warning('字段配置中，字段英文名称必须大于2个字符')
            return
          }
          if (!/^[a-z]+[a-z0-9_]+$/.test(field.variable)) {
            this.$tip.warning('字段配置中，字段英文名称必须为小写字母，特殊字符仅允许使用"_"，且不能以"_"和数字开头')
            return
          }
          if (field.label.trim() === '') {
            this.$tip.warning('字段配置中，字段中文名称不能为空')
            return false
          }
        }
        // 英文名称重复验证
        for (const field of this.fields) {
          if (this.fields.filter(f => f.variable === field.variable).length > 1) {
            this.$tip.warning('字段配置中，字段英文名称不可重复')
            return false
          }
        }
        // 中文名称重复验证
        for (const field of this.fields) {
          if (this.fields.filter(f => f.label === field.label).length > 1) {
            this.$tip.warning('字段配置中，字段中文名称不可重复')
            return false
          }
        }
      }
      return true
    }
  },
  created () {
    this.config({
      api: '/template/fieldType',
      'field.id': 'id'
    })
  }
}
</script>
